module.exports = __webpack_public_path__ + "static/media/Laurie.be19b0d9.webp";